import { all, call, put, takeLatest } from "redux-saga/effects";

import {
  getListManagerOfDepartmentStart,
  getListManagerOfDepartmentSuccess,
  getListManagerOfDepartmentFailed,
} from "../redux/getListManagerOfDepartment";
import { getListManagerOfDepartmentApi } from "core/http/service/timeKeeping";

function* getListManagerOfDepartmentWork() {
  try {
    const res = yield call(getListManagerOfDepartmentApi);

    yield put({
      type: getListManagerOfDepartmentSuccess.type,
      payload: res?.map((it) => ({
        label: `${it?.name} - ${it?.positionName}`,
        value: it?.employeeCode,
      })),
    });
  } catch (error: any) {
    yield put({
      type: getListManagerOfDepartmentFailed.type,
    });
  }
}

function* watchGetListManagerOfDepartment() {
  yield takeLatest(
    getListManagerOfDepartmentStart.type,
    getListManagerOfDepartmentWork
  );
}

export default function* getListManagerOfDepartmentSaga() {
  yield all([watchGetListManagerOfDepartment()]);
}
